import PropTypes from 'prop-types';
import compose from '../hoc/compose';
import template from './panelHeaderCenteredText.jsx';
import textTypes from '../controls/textLabel/textTypes';
var PanelHeaderCenteredText = template;
PanelHeaderCenteredText.displayName = 'PanelHeaderCenteredText';
PanelHeaderCenteredText.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleType: PropTypes.oneOf(textTypes.PANEL_HEADER_CENTERED_TEXT_TITLE_TYPES),
  subtitle: PropTypes.string,
  onHelp: PropTypes.func,
  onClose: PropTypes.func
};
PanelHeaderCenteredText.defaultProps = {
  titleType: textTypes.PANEL_HEADER_CENTERED_TEXT_TITLE_DEFAULT_TYPE
};
export default compose(PanelHeaderCenteredText);